export default "__VITE_ASSET__2f482725__"